//	Core
import Mmenu from 'mmenu-js/dist/core/oncanvas/mmenu.oncanvas';

//	Core add-ons
import offcanvas from 'mmenu-js/dist/core/offcanvas/mmenu.offcanvas';
import screenReader from 'mmenu-js/dist/core/screenreader/mmenu.screenreader';
import scrollBugFix from 'mmenu-js/dist/core/scrollbugfix/mmenu.scrollbugfix';

//	Add-ons
import navbars from 'mmenu-js/dist/addons/navbars/mmenu.navbars';

Mmenu.addons = {
  //	Core add-ons
  offcanvas,
  screenReader,
  scrollBugFix,

  //	Add-ons
  navbars
};

//  Export module
export default Mmenu;

//	Global namespace
if (window) {
  window.Mmenu = Mmenu;
}
